 <template>
  <div>
    <h1 class="page-header">Calculators, by Michael J. Nicholson</h1>
    <p>Sample app written using Vue3 and Vuex 4.0, with Element-plus UI</p>
    <p>
      Source code can be found
      <a href="https://gitlab.com/michjnich/calcs">here</a>
    </p>
    <div>
      <code>
        "dependencies": { "core-js": "^3.6.5", "element-plus": "^1.0.2-beta.32",
        "vue": "^3.0.0", "vue-router": "^4.0.4", "vuex": "^4.0.0" },
      </code>
    </div>
  </div>
</template>